<template>
  <v-row no-gutters class="pt-5">
    <v-col style="border: 1px solid rgba(0, 0, 0, 0.12)">
      <v-data-table :headers="headers" :items="items" :items-per-page="-1" hide-default-footer>
        <template #item.actions="{ item }">
          <dots-menu
            :items="dotsItems"
            @edit="$emit('toggleDialog', { type: 'input', item })"
            @delete="$emit('toggleDialog', { item })"
          />
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'FormPrintList',
  components: {
    DotsMenu,
  },
  data: () => ({
    dotsItems: [{ name: 'edit' }, { name: 'delete' }],
  }),
  computed: {
    dataSources: get('layers/metadata'),
    layers: get('layers/layers'),
    smartMatch: get('smartMatch/profiles'),
    formPrints: get('formPrint/formPrints'),
    formPrintTemplates: get('formPrint/formPrintTemplates'),
    headers() {
      const inputs = ['name', 'form', 'smart_match', 'layer', 'relation_attribute'].map(header => {
        return {
          value: header,
          text: this.$i18n.t(`admin.formPrint.${header}`),
          sortable: false,
          align: 'center',
        };
      });
      return [...inputs, { value: 'actions', sortable: false }];
    },
    items() {
      return this.formPrints.map(form => {
        const dataSourceName = this.layers[form.layer].data_source_name;
        return {
          id: form.id,
          name: form.name,
          form: this.formPrintTemplates.find(el => el.name === form.form).verbose_name,
          smart_match: this.smartMatch[form.smart_match].name,
          layer: this.layers[form.layer].name,
          relation_attribute:
            this.dataSources[dataSourceName].attributes_schema.attributes.find(
              attr => attr.name === form.relation_attribute
            )?.verbose_name || '-',
          ...form.settings,
        };
      });
    },
  },
};
</script>
